module.exports = __webpack_public_path__ + "static/media/mars-explor.d619ed62.png";